import classNames from 'classnames/bind';
import { graphql, useStaticQuery } from 'gatsby';
import GatsbyImage from 'gatsby-image';
import React from 'react';

import Accordion from 'components/pages/home/faq/accordion';
import Heading from 'components/shared/heading';

import styles from './faq.module.scss';

const cx = classNames.bind(styles);

const SOCIAL_BUTTONS = [
  {
    name: 'instagram',
    link: 'https://instagram.com',
  },
  {
    name: 'twitter',
    link: 'https://twitter.com',
  },
  {
    name: 'tiktok',
    link: 'https://tiktok.com',
  },
  {
    name: 'facebook',
    link: 'https://instagram.com',
  },
];

const Faq = () => {
  const { ctaBackground } = useStaticQuery(IMAGE_QUERY);

  return (
    <section className={cx('container', 'wrapper')} id="faq">
      <Heading className={cx('title')} size="lg" tag="h2" theme="secondary">
        FAQ
      </Heading>
      <div className={cx('content')}>
        <div className={cx('accordion-wrapper')}>
          <Accordion id="accordion" />
        </div>
        <div className={cx('cta')}>
          <div className={cx('cta-background')}>
            <GatsbyImage fluid={ctaBackground.childImageSharp.fluid} fadeIn={false} />
          </div>
          <Heading className={cx('cta-title')} tag="h3" theme="primary">
            JOIN US
          </Heading>
          <div className={cx('cta-links')}>
            {SOCIAL_BUTTONS.map(({ name, link }, i) => (
              <a className={cx('link')} href={link} rel="noopener noreferrer" key={`${link}-${i}`}>
                <span>{name}</span>
                <span className={cx('dummy')} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;

const IMAGE_QUERY = graphql`
  query {
    ctaBackground: file(relativePath: { eq: "pages/home/faq/background.png" }) {
      id
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`;
